module.exports = __webpack_public_path__ + "flyer_background_cupcake_3_094-21289e01755ecec43b4e18491af4ed6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_cupcake_3_094.jpg
// module id = 1633
// module chunks = 1